import type { RoutesFilter } from '../models';
import { pickDriverLabelsForIds } from './driverAutocomplete';

export function routesFilterForApiQuery(
  filters: RoutesFilter | undefined
): RoutesFilter | undefined {
  if (!filters) return undefined;
  const { driverLabelsById: _omit, ...rest } = filters;
  return Object.keys(rest).length > 0 ? rest : undefined;
}

export function buildAppliedRoutesFilterFromLocal(
  localFilter: RoutesFilter
): RoutesFilter {
  const appliedRoutesFilter: RoutesFilter = {};

  const trimmedLogisticOperatorId = localFilter.logisticOperatorId?.trim();
  if (trimmedLogisticOperatorId) {
    appliedRoutesFilter.logisticOperatorId = trimmedLogisticOperatorId;
  }

  const driverIds = (localFilter.driverIds ?? [])
    .map((id) => id.trim())
    .filter((id) => id.length > 0);
  if (driverIds.length > 0) {
    const uniqueIds = [...new Set(driverIds)];
    appliedRoutesFilter.driverIds = uniqueIds;
    const labels = pickDriverLabelsForIds(
      uniqueIds,
      localFilter.driverLabelsById
    );
    if (labels) {
      appliedRoutesFilter.driverLabelsById = labels;
    }
  }

  const trimmedCommerceId = localFilter.commerceId?.trim();
  if (trimmedCommerceId) {
    appliedRoutesFilter.commerceId = trimmedCommerceId;
  }

  const trimmedRouteId = localFilter.routeId?.trim();
  if (trimmedRouteId) {
    appliedRoutesFilter.routeId = trimmedRouteId;
  }

  const trimmedRouteName = localFilter.routeName?.trim();
  if (trimmedRouteName) {
    appliedRoutesFilter.routeName = trimmedRouteName;
  }

  const trimmedShippingNumber = localFilter.shippingNumber?.trim();
  if (trimmedShippingNumber) {
    appliedRoutesFilter.shippingNumber = trimmedShippingNumber;
  }

  if (localFilter.scheduledFrom) {
    appliedRoutesFilter.scheduledFrom = localFilter.scheduledFrom;
  }

  if (localFilter.scheduledTo) {
    appliedRoutesFilter.scheduledTo = localFilter.scheduledTo;
  }

  if (localFilter.status) {
    appliedRoutesFilter.status = localFilter.status;
  }

  return appliedRoutesFilter;
}
